export const CategoryNavigation = (target: HTMLDivElement) => {

  const el = {
    root: target,
    categoryLink: target.querySelector<HTMLAnchorElement>('.category-card'),
    header: target.querySelector<HTMLHeadingElement>('.category-navigation__title'),
  }

  const method = {
    init: () => {
      window.addEventListener('resize', method.onResize)
    },

    onResize: (e: Event) => {
      if (!el.categoryLink || !el.header) return
      const categoryLinkHeight = el.categoryLink.clientHeight
      const headerHeight = el.header.clientHeight
      const headerMargin = 30
      el.root.style.marginTop = `-${(categoryLinkHeight / 2) + headerHeight + headerMargin}px`
    }
  }

  method.init()
}